<template>
  <div>
    <van-col :span="24" style="text-align: center;">
      审批单详情
    </van-col>
    <van-col v-if="approveInfo" :span="24">
      <base-input v-model="approveInfo.create_time" label="申请时间" readonly />
      <base-input v-model="approveInfo.code" label="编号" readonly />
      <base-input v-model="approveInfo.approve_item_name" label="审批事项" readonly />
      <base-input v-model="approveInfo.approve_status_name" label="审批状态" readonly />
      <base-input v-model="approveInfo.pay_status_name" label="打款状态" readonly />
      <base-input v-model="approveInfo.get_invoice_status_name" label="回票状态" readonly />
      <base-input v-model="approveInfo.corp_name" label="主体" readonly />
      <base-input v-model="approveInfo.approve_type_name" label="审批类型" readonly />
      <base-input v-model="approveInfo.get_invoice_date" label="回票日期" readonly />
      <base-input-number v-model="approveInfo.approve_amount" label="费用金额" readonly />
      <base-input v-model="approveInfo.corp_expend_info" label="对公支出信息" readonly />
      <base-textarea v-model="approveInfo.remark" label="备注" readonly />
      <base-input v-model="approveInfo.dept_name" label="部门" readonly />
      <base-input v-model="approveInfo.create_name" label="创建人" readonly />
      <van-tag type="primary">附件信息</van-tag>
      <van-row v-for="(file, index) in approveInfo.files" :key="index">
        <van-col :span="24">
          <van-field v-model="file.file_name" :label="file.file_type_name" readonly />
        </van-col>
      </van-row>
    </van-col>
    <van-col v-if="approveInfo && approveInfo.approve_status === 1 && canOperate" :span="24" style="text-align: center;">
      <base-button :disabled="!approveEmp || approveEmp.approve_status !== 1"
        type="primary" size="large" @click="handleApproveStatus(2, '通过')">通过</base-button>
      <base-button :disabled="!approveEmp || approveEmp.approve_status !== 1"
        type="danger" size="large" @click="showApproveForm = true">驳回</base-button>
    </van-col>

    <van-popup
        v-model="showApproveForm"
        closeable
        position="center"
        :style="{ width: '90%' }"
      >
        <van-col :span="24">
          <base-textarea v-model="remark" label="驳回原因" />
        </van-col>
        <van-col :span="24">
          <base-button type="primary" size="large" @click="handleApproveStatus(3, '驳回')">确定</base-button>
        </van-col>
      </van-popup>

    <init :init-states="initStates" @after-init="init" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Init from '@/components/base/init'
import { getApproveEmpList } from '@/api/settings/approve-manage'
import { getSysDictionariesList } from '@/api/commons'
import { getApproveInfoList, approveInfo } from '@/api/settings/approve-info'
export default {
  name: 'ApproveInfoDetail',
  components: { Init },
  data() {
    return {
      orderId: null,
      approveInfo: null,
      showApproveForm: false,
      approveEmpList: [],
      approveEmp: null,
      remark: '',
      deptMap: new Map(),
      dictList: [],
      initStates: [{
        key: 'dept/init'
      }]
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'deptData', 'deptMapOfIdsArray']),
    canOperate() {
      this.approveEmp = this.approveEmpList.find(approveEmp => approveEmp.approve_emp_id === this.userInfo.emp_id)
      return this.approveEmp && this.approveEmp.op_type === 1 // 审批人
    }
  },
  created() {
    this.orderId = parseInt(this.$route.query.id)
    if (this.orderId) {
      this.querySysDictionariesList().then(() => {
        this.query()
      })
    } else {
      this.error('请求参数错误，请您重新进入')
      this.$router.back()
      return
    }
  },
  methods: {
    init() {
      this.deptMap.clear()
      this.Utils.setTreeData(this.deptData, row => {
        this.deptMap.set(row.id, row)
      })
    },
    handleApproveStatus(status, text) {
      if (status === 3 && this.remark.trim() === '') {
        this.error('请您填写驳回原因')
        return
      }
      this.confirm(`确定<label class="${status === 2 ? 'tip-msg' : 'err-msg'}">${text}</label>此审批单吗？`)
        .then(async() => {
          approveInfo({
            id: this.orderId,
            approve_status: status,
            remark: this.remark.trim()
          }).then(resp => {
            this.showApproveForm = false
            this.query()
            this.success(resp.msg)
          })
        }).catch(_ => {})
    },
    querySysDictionariesList() {
      return new Promise((resolve, reject) => {
        getSysDictionariesList().then(resp => {
          this.dictList = resp.rows || []
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    query() {
      getApproveInfoList({
        id: this.orderId
      }).then(resp => {
        const rows = resp.rows || []
        if (rows.length > 0) {
          this.approveInfo = rows[0]
          const approveStatus = this.CONST.APPROVE_STATUS
            .find(status => status.id === this.approveInfo.approve_status)
          this.approveInfo.approve_status_name = approveStatus ? approveStatus.name : ''

          const payStatus = this.CONST.APPROVE_PAY_STATUS
            .find(status => status.id === this.approveInfo.pay_status)
          this.approveInfo.pay_status_name = payStatus ? payStatus.name : ''

          const getInvoiceStatus = this.CONST.APPROVE_GET_INVOICE_STATUS
            .find(status => status.id === this.approveInfo.get_invoice_status)
          this.approveInfo.get_invoice_status_name = getInvoiceStatus ? getInvoiceStatus.name : ''

          const approveType = this.CONST.APPROVE_TYPE
            .find(status => status.id === this.approveInfo.approve_type)
          this.approveInfo.approve_type_name = approveType ? approveType.name : ''

          this.approveInfo.corp_name = this.dictList
            .find(dict => dict.id === this.approveInfo.corp).name

          const deptIdArray = this.deptMapOfIdsArray[this.approveInfo.dept_id]
          this.approveInfo.dept_name = deptIdArray.map(deptId => this.deptMap.get(deptId).label).join(' / ')
        
          if (this.approveInfo.files && this.approveInfo.files.length > 0) {
            this.approveInfo.files.forEach(file => {
              file.file_name = file.file_url.substring(file.file_url.lastIndexOf('/') + 1)
              file.file_type_name = this.dictList.find(dict => dict.id === +file.file_type).name
            })
          }

          this.approveEmpList = this.approveInfo.op_emps
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/approve-info/detail.vue